import { useEffect, useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";

export default function CustomMessageModal({
    show,
    onHide,
    onSubmit,
    sending,
    leadCount,
    targetLabel,
}) {
    const [messageText, setMessageText] = useState("");
    const maxLength = 1000;

    useEffect(() => {
        if (!show) {
            setMessageText("");
        }
    }, [show]);

    const remaining = maxLength - messageText.length;
    const isValidMessage = messageText.trim().length >= 3;

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!isValidMessage || sending) {
            return;
        }

        onSubmit(messageText);
    };

    const description =
        leadCount === 1
            ? `A mensagem será enviada para ${targetLabel || "o lead selecionado"}.`
            : `A mensagem será enviada para ${targetLabel || `${leadCount} leads`}.`;

    return (
        <Modal show={show} onHide={onHide} centered>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Mensagem personalizada</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-muted">{description}</p>
                    <Alert variant="info" className="py-2">
                        O envio continua mesmo se você trocar de aba ou minimizar o navegador.
                    </Alert>
                    <Form.Group>
                        <Form.Label>Texto da mensagem</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            maxLength={maxLength}
                            value={messageText}
                            onChange={(event) => setMessageText(event.target.value)}
                            placeholder="Digite o texto que será enviado no WhatsApp"
                            disabled={sending}
                            required
                        />
                        <small className="text-muted d-block text-right">
                            {remaining} caractere{remaining === 1 ? "" : "s"} restantes
                        </small>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="link" onClick={onHide} disabled={sending}>
                        Cancelar
                    </Button>
                    <Button type="submit" disabled={!isValidMessage || sending}>
                        {sending
                            ? "Enviando... (você pode usar outras abas)"
                            : "Enviar mensagem"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}